<div *ngIf="tileRows != null">
    <table style="width: 100%;">
        <tbody *ngFor="let data of dataRows">
            <tr *ngFor="let tr of tileRows">
                <td *ngFor="let tile of tr.tiles"
                    [style.text-align]="tile.AlignContent != null ? tile.AlignContent : 'left'"
                    [style.vertical-align]="tile.VerticalAlign != null ? tile.VerticalAlign : 'top'"
                    [attr.rowspan]="tile.RowSpan > 1 ? tile.RowSpan : 1"
                    [attr.colspan]="tile.ColSpan > 1 ? tile.ColSpan : 1">

                    <app-dynamic-layout-tile [tile]="tile" [data]="getTileData(data, tile)">
                    </app-dynamic-layout-tile>
                </td>
            </tr>
        </tbody>
    </table>
</div>
